import { getIconByExtension } from '@bimser/core';
import { DmObjectType } from '../../entities/DmObjectType';
import IconEmpty from '@bimser/icons/24/empty-icon';
import { getIconByName } from '@bimser/core/dist/utils/getIconByExtension';

export function getDmIcon(
	type: DmObjectType,
	className?: string,
	fileName?: string,
	iconSize: 16 | 24 | 32 | 48 = 32
) {
	const wh = iconSize + 'px';

	switch (type) {
		case DmObjectType.Content:
		case DmObjectType.File: {
			const extensionArr = fileName?.split('.') || [];
			const extension = extensionArr[extensionArr.length - 1] || '';

			return getIconByExtension(extension, className, iconSize);
		}
		case DmObjectType.Folder:
			const IconDirectory = getIconByName[iconSize]('folder2', IconEmpty);

			return (
				<IconDirectory
					width={wh}
					height={wh}
					className={className}
				/>
			);
		case DmObjectType.Repository:
			const IconRepositories = getIconByName[iconSize]('reporsitories2', IconEmpty);

			return (
				<IconRepositories
					width={wh}
					height={wh}
					className={className}
				/>
			);
		case DmObjectType.Shortcut:
			const IconShortcut = getIconByName[iconSize]('shortcut', IconEmpty);

			return (
				<IconShortcut
					width={wh}
					height={wh}
					className={className}
				/>
			);
	}
}
